// @flow

import React from 'react';
import { withTheme } from 'styled-components';
import type { Theme } from '../../types';
import {
  CarBlockOverlay,
  Content,
  DeliveryTime,
  Footer,
  Header,
  Image,
  Package,
  Remarks,
  Price,
  Promotion,
  SubTitle,
  Title,
} from './components';
import {
  DefaultContainer,
} from './containers';
import Tags from '../tags';
import { FakeButton } from '../button';

type Props = {
  basePrice?: string,
  deliveryText: string,
  consumerPrice: string,
  image: string,
  isReserved?: boolean,
  link: string,
  overlay?: boolean,
  overlayText?: string,
  packageName?: string,
  payment: string,
  promotionText?: string,
  remarkText: string,
  reservedText?: string,
  subTitle: string,
  tags?: Array<string>,
  title: string,
  onClick: Function,
  buttonText: string,
  theme: any,
};

const CarBlock = ({
  basePrice,
  consumerPrice,
  deliveryText,
  image,
  isReserved = false,
  link,
  overlay = false,
  overlayText = '',
  packageName = '',
  payment,
  promotionText = '',
  remarkText,
  reservedText = '',
  subTitle,
  tags = [],
  title,
  onClick,
  theme,
  buttonText,
}: Props) => {
  const { carblock: { buttonProps } }: Theme = theme;
  return (
    <>
      <DefaultContainer link={link} overlay={overlay} onClick={onClick}>
        {promotionText && <Promotion>{promotionText}</Promotion>}
        <Header>
          <Title singleLine={!!packageName}>{title}</Title>
          {packageName && <Package>{packageName}</Package>}
          <SubTitle>{subTitle}</SubTitle>
        </Header>
        <Image
          src={image}
          alt={title}
          reservedText={reservedText}
          isReserved={isReserved}
        />
        {tags && <Tags tags={tags} />}
        <Content>
          <Price
            from={basePrice}
            price={consumerPrice}
            payment={payment}
          />
          <FakeButton
            colors={buttonProps.colors}
            size={buttonProps.size}
            variant={buttonProps.variant}
            fullWidth
            caret
          >
            {buttonText}
          </FakeButton>
          <Footer>
            <Remarks>{remarkText}</Remarks>
            {packageName && <DeliveryTime>{deliveryText}</DeliveryTime>}
          </Footer>
        </Content>
      </DefaultContainer>
      {overlay && <CarBlockOverlay overlayText={overlayText} />}
    </>
  );
};

CarBlock.defaultProps = {
  basePrice: null,
  isReserved: false,
  overlay: false,
  overlayText: '',
  packageName: '',
  promotionText: '',
  reservedText: '',
  tags: [],
};

export default withTheme(CarBlock);
